import { render, staticRenderFns } from "./modalAutorizadores.vue?vue&type=template&id=2a084b0e&"
import script from "./modalAutorizadores.vue?vue&type=script&lang=ts&"
export * from "./modalAutorizadores.vue?vue&type=script&lang=ts&"
import style0 from "./modalAutorizadores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports